// extracted by mini-css-extract-plugin
export default {"ModalPadding":"0.5rem","modalBody":"ModalBody_modalBody__J10kw"};